<template>
  <div>
    <v-form v-model="formValid">
      <v-jsonschema-form
        v-if="currentSchema"
        :schema="currentSchema"
        :model="currentScope"
        :options="options"
        :key="componentKey"
        @error="showError"
        @input="input"
        @change="change"
      ></v-jsonschema-form>
    </v-form>
    <!-- DEBUG {{ currentScope }} -->
    <v-flex>
      <v-btn color="secondary" @click="resetScope()">reset scope</v-btn>
    </v-flex>
  </div>
</template>


<i18n>
{
  "de": {
    "scope_region_label": "Region",
    "scope_division_label": "Division",
    "scope_site_label": "Standort",
    "scope_area_label": "Bereich",
    "scope_area_exclusion_label": "Ausgeschlossene Bereiche",
    "scope_process_exclusion_label": "Ausgeschlossene Prozesse",
    "scope_process_label": "Prozess"
  },
  "en": {
    "scope_region_label": "Region",
    "scope_division_label": "Division",
    "scope_site_label": "Site",
    "scope_area_label": "Area of application",
    "scope_area_exclusion_label": "Excluded areas of application",
    "scope_process_exclusion_label": "Excluded processes",
    "scope_process_label": "Process"
  }
}
</i18n>

<script>
import { mapGetters } from "vuex";
import { api as confApi } from "@/store/modules/configuration";

import VJsonschemaForm from "@koumoul/vuetify-jsonschema-form";

export default {
  props: {
    scope: {
      type: [Array, Object],
      default: () => ({})
    },
    audittype: {
      type: String,
      default: ""
    }
  },
  components: {
    VJsonschemaForm
  },
  created() {
    console.log("ScopeSelect:mounted", this.scope);
    if (!(this.scope instanceof Array)) {
      this.currentScope = this.scope;
    }
  },
  data() {
    return {
      x: false,
      currentScope: {},
      componentKey: 1,
      formValid: false,
      options: {
        debug: true,
        disableAll: false,
        autoFoldObjects: true
      }
    };
  },
  computed: {
    ...mapGetters(confApi.namespace, [
      confApi.getters.audit,
      confApi.getters.scopes
    ]),
    currentSchema() {
      console.log("Config Schema", this.audit.schemaScope);
      return (
        this.audit.schemaScope || {
          $id: "audit.schema.json",
          $schema: "http://json-schema.org/draft-07/schema#",
          type: "object",
          required: ["plant", "productline"],
          properties: {
            type: {
              type: "string",
              const: "customdata"
            },
            plant: {
              title: "Werk",
              type: "string",
              enum: ["Munich", "Cracow", "Styr", "Pinetown", "St. Petersburg"]
            },
            productline: {
              title: "Produktlinie",
              type: "string",
              enum: ["TGX", "TGL", "TGM", "TGS", "VW"]
            },
            fahrgestellnummer: {
              title: "Fahrgestellnummer",
              type: "string"
            },
            productionnumber: {
              title: "Produktionsnummer",
              type: "integer"
            },
            productiondate: {
              title: "Produktionsdatum",
              type: "string",
              format: "date"
            },
            lenkung: {
              title: "Lenkung",
              type: "string",
              enum: ["LL", "RL"]
            }
          }
        }
      );
    }
  },
  methods: {
    showError(err) {
      console.log("VuetifyForms:Error", err);
    },
    resetScope() {
      // TODO: Resetting scope does not work
      this.componentKey = this.componentKey + 1;
      this.currentScope = JSON.parse(JSON.stringify({}));
    },
    input() {
      console.log("update:scope", this.currentScope);
      this.$emit("update:scope", this.currentScope);
    },
    change() {}
  }
};
</script>
